<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                loadForm: () => import('../forms/LoadForm'),
                queenPurchaseForm: () => import('../forms/QueenPurchaseForm'),
                fields: [
                    { type: 'autocomplete', text: 'Queen Purchase', value: 'queenPurchaseId', rules: [], form: () => import('./QueenPurchaseForm'), apiMethod: 'QueenPurchases', claim: 'QueenPurchases' },
                    { type: 'text', text: 'Queen Number', value: 'queenNumber', rules: [v => !(v && v.length > 50) || 'Queen Number must be less than 50 characters'], maxLength: 50 },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Load', value: 'loadId', rules: [v => !!v || 'Load is required'], isRequired: true, form: () => import('./LoadForm'), apiMethod: 'Loads', claim: 'Loads' },
                ],
                apiMethod: 'QueenIntroductions',
                formTitle: 'Queen Introduction',
            }
        },
    };
</script>
